import AppHeader from '@/components/Header/Header.vue'
import AppFooter from '@/components/Footer/Footer.vue'
import MoreInfo from '@/components/MoreInfo.vue'
import SignupForm from '@/components/SignupForm.vue'

export default {
  name: 'wordpress-integration',
  components: {
    AppHeader,
    AppFooter,
    MoreInfo,
    SignupForm
  },
  props: {
    name: String
  },
  data: function () {
    return {
      email: "",
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    };
  },
  methods: {
    isEmailValid() {
      return this.email == "" ?
        "" :
        this.reg.test(this.email) ?
        "has-success" :
        "has-error";
    },
    createAccount(e) {
      e.preventDefault();
      if (this.isEmailValid() != "has-error") {
        window.location =
          "https://app.verloop.io/app/signup/email?utm_source=top-fold&utm_medium=web-client&utm_campaign=direct-click&email=" +
          this.email;
      }
    }
  }
}